module.exports = __webpack_public_path__ + "fonts/Courier-Bold.ddcfa4db.eot";